/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_ExclusiveInputs */

const en_member_exclusive = /** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Exclusive`)
};

const id_member_exclusive = /** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksklusif Anggota`)
};

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const es_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const fr_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const de_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const ja_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const zh_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const ar_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const it_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const ru_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const pt_member_exclusive = en_member_exclusive;

/** @type {(inputs: Member_ExclusiveInputs) => LocalizedString} */
const ko_member_exclusive = en_member_exclusive;

/**
* | output |
* | --- |
* | "Member Exclusive" |
*
* @param {Member_ExclusiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const member_exclusive = /** @type {((inputs?: Member_ExclusiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_ExclusiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_member_exclusive(inputs)
	if (locale === "es") return es_member_exclusive(inputs)
	if (locale === "fr") return fr_member_exclusive(inputs)
	if (locale === "de") return de_member_exclusive(inputs)
	if (locale === "ja") return ja_member_exclusive(inputs)
	if (locale === "zh") return zh_member_exclusive(inputs)
	if (locale === "ar") return ar_member_exclusive(inputs)
	if (locale === "id") return id_member_exclusive(inputs)
	if (locale === "it") return it_member_exclusive(inputs)
	if (locale === "ru") return ru_member_exclusive(inputs)
	if (locale === "pt") return pt_member_exclusive(inputs)
	return ko_member_exclusive(inputs)
});